import React from 'react';

/**
 * Fixed, full-viewport decorative background for the trader area.
 * Renders the three blurred gradient blobs from the mobile-trader-template,
 * tinted by the tenant's brand colours (primary / accent / third chart tone;
 * indigo / purple / emerald until a tenant sets its own). Purely decorative — pointer-events disabled.
 *
 * Meant to be rendered once inside a `.trader-theme` wrapper which sets the
 * base surface color (#0a0a0f in dark, soft off-white in light).
 */
const TraderBackground: React.FC = () => {
    return (
        <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
            <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] rounded-full bg-primary/20 blur-[120px]" />
            <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-chart-2/20 blur-[120px]" />
            <div className="absolute top-[40%] left-[60%] w-[40%] h-[40%] rounded-full bg-chart-3/10 blur-[120px]" />
        </div>
    );
};

export default TraderBackground;
